import { useState } from 'react';

export const useVisibilityToggle = (initialVisibility: boolean = false) => {
	const [isVisible, toggleVisibility] = useState(initialVisibility);
	const show: any = () => toggleVisibility(true);
	const hide: any = () => toggleVisibility(false);

	return [isVisible, show, hide];
};
